 const twitterIcon =<svg
id="twitter_icon_ctt"
width="17.1"
height="14"
x="0"
y="0"
version="1.1"
viewBox="0 0 17.1 14"
xmlSpace="preserve"
>
<path d="M8.7 1.7C9.4.5 10.8-.2 12.2 0c.9.1 1.5.6 2.2 1.1.7-.2 1.5-.5 2.2-.8-.3.7-.8 1.4-1.5 1.9.7-.1 1.3-.4 2-.5-.5.7-1.2 1.2-1.8 1.8.1 2.5-.7 5.1-2.4 7-1.7 2.2-4.7 3.5-7.5 3.5-1.9.1-3.8-.6-5.4-1.5 1.8.2 3.7-.4 5.1-1.5-1.5 0-2.7-1.1-3.2-2.4h1.5c-.8-.3-1.6-.9-2.2-1.8C.8 6.2.7 5.5.6 4.9c.5.2 1 .4 1.5.5C1.5 4.7.8 3.9.7 3c-.2-.8.1-1.6.4-2.4.7.7 1.4 1.5 2.2 2 1.5 1 3.2 1.6 5 1.7 0-.9-.1-1.8.4-2.6z"></path>
</svg>

export default twitterIcon


// WEBPACK FOOTER //
// blocks/click-to-tweet/icon.js